import { WrapperGS } from '../core/WrapperGS';

export class AnchorGS extends WrapperGS<HTMLAnchorElement>
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "a";
    }

    constructor(el: HTMLAnchorElement|string)
    {
        super(el);
    }

    public get href() { return this.el.href; }
    public set href(value: string) { this.el.href = value; }

    public get target() { return this.el.target; }
    public set target(value: string) { this.el.target = value; }

    public get download() { return this.el.download; }
    public set download(value: string) { this.el.download = value; }

    public get rel() { return this.el.rel; }
    public set rel(value: string) { this.el.rel = value; }
}
WrapperGS.ExtendComponentsByHTMLElement(AnchorGS);
